import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import DestinationShowcase from './components/DestinationShowcase';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '亚洲春色',
    url: 'https://hvrxld.cn',
    description: '汇聚东亚、东南亚、南亚春季最绚烂的自然与人文景观，带你领略樱花、油菜花、热带花海的极致美景。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hvrxld.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEO
        title="亚洲春色 - 感受春日亚洲最美风情"
        description="亚洲春色汇聚东亚、东南亚、南亚春季最绚烂的自然与人文景观，带你领略樱花、油菜花、热带花海的极致美景。探索亚洲春色的独特魅力，规划你的春季亚洲之旅，感受不同文化交融下的春日盛景。"
        keywords="亚洲春色,亚洲春季旅游,亚洲春天美景,亚洲赏花攻略,春季亚洲自然风光,东亚春色景点,亚洲春日人文风情"
        canonicalUrl="https://hvrxld.cn"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <DestinationShowcase />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}